import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthShell, Field } from "./Login";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      navigate("/account");
    } catch (e) { setError(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Join us for faster checkout & order tracking">
      <form onSubmit={submit} className="space-y-4" autoComplete="off">
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3" data-testid="register-error">{error}</p>}
        <Field label="Full Name" value={form.name} onChange={(v) => setForm((f) => ({ ...f, name: v }))} testid="register-name" name="reg_name" autoComplete="off" />
        <Field label="Email" type="email" value={form.email} onChange={(v) => setForm((f) => ({ ...f, email: v }))} testid="register-email" name="reg_email" autoComplete="off" />
        <Field label="Phone (optional)" value={form.phone} onChange={(v) => setForm((f) => ({ ...f, phone: v }))} testid="register-phone" name="reg_phone" autoComplete="off" />
        <Field label="Password" type="password" value={form.password} onChange={(v) => setForm((f) => ({ ...f, password: v }))} testid="register-password" name="reg_password" autoComplete="new-password" />
        <button disabled={loading} className="w-full inline-flex justify-center items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-semibold py-3 rounded-lg transition disabled:opacity-60" data-testid="register-submit">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Create Account
        </button>
        <p className="text-sm text-center text-slate-500">Already have an account? <Link to="/login" className="text-amber-600 font-semibold">Log in</Link></p>
      </form>
    </AuthShell>
  );
}
